global.$$require_external = typeof require !== "undefined" ? (m) => require(m) : () => null;